module.exports = __webpack_public_path__ + "static/media/unchecked-icon.89cdef93.svg";